import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import './Duration.scss'
import { LuxDatePicker, LuxSelect, Color } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
// import { dateFormat } from '@/root.component'

const Duration = (props) => {
    const { form, onSave, recipientList, disabled, pickerClass } = props

    const intl = useIntl()

    const componentClass = 'smart-new-activity-action-task-duration'

    const [isPickerStartVisible, setIsPickerStartVisible] = useState(false)
    const [isPickerEndVisible, setIsPickerEndVisible] = useState(false)

    useEffect(() => {
        const pickerIconStart = document
            .getElementsByClassName(
                `smart-new-activity-action-task-duration__picker ${pickerClass || ''} start`
            )[0]
            .getElementsByClassName('p-datepicker-trigger')[0]
        const pickerIconEnd = document
            .getElementsByClassName(
                `smart-new-activity-action-task-duration__picker ${pickerClass || ''} end`
            )[0]
            .getElementsByClassName('p-datepicker-trigger')[0]
        pickerIconStart.addEventListener('click', () =>
            setIsPickerStartVisible(
                !document.getElementsByClassName('action-duration-start-picker')[0]
            )
        )
        pickerIconEnd.addEventListener('click', () =>
            setIsPickerEndVisible(!document.getElementsByClassName('action-duration-end-picker')[0])
        )
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            const pickerStart = document.getElementsByClassName('action-duration-start-picker')[0]
            const pickerEnd = document.getElementsByClassName('action-duration-end-picker')[0]
            if (!!pickerStart && !pickerStart.contains(event.target)) {
                setIsPickerStartVisible(false)
            }
            if (!!pickerEnd && !pickerEnd.contains(event.target)) {
                setIsPickerEndVisible(false)
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const onFocus = () => {
        setIsPickerStartVisible(true)
    }

    const onFocusEnd = () => {
        setIsPickerEndVisible(true)
    }

    const onVisibleChange = (e) => {}

    const onStartChangeCallback = (value) => {
        onSave({ startDate: value, endDate: null })
        setIsPickerStartVisible(false)
    }

    const onEndChangeCallback = (value) => {
        onSave({ endDate: value })
        setIsPickerEndVisible(false)
    }

    return (
        <div className={`${componentClass}`}>
            <LuxDatePicker
                containerClasses={`${componentClass}__picker ${pickerClass || ''} start`}
                additionalProps={{
                    panelClassName: 'smart-wardrobe-datepicker action-duration-start-picker',
                    appendTo: 'self',
                }}
                value={form.startDate}
                mandatory={true}
                onChangeCallback={onStartChangeCallback}
                minDate={new Date()}
                label={intl.formatMessage({
                    id: 'modals.new.activity.section.action.task.duration',
                    defaultMessage: 'Select start date',
                })}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.task.duration.start.placeholder',
                    defaultMessage: 'Select start date',
                })}
                intl={intl}
                locale={props.language?.split('-')[0] || 'en'}
                showCustom
                visible={isPickerStartVisible}
                onFocus={onFocus}
                onVisibleChange={onVisibleChange}
                style={{ backgroundColor: Color.WHITE }}
                disabled={disabled}
                dateFormat={props.language?.split('-')[0] === 'tr' ? "dd/mm/yy" : undefined}
            />
            <LuxDatePicker
                intl={intl}
                locale={props.language?.split('-')[0] || 'en'}
                containerClasses={`${componentClass}__picker ${pickerClass || ''} end`}
                additionalProps={{
                    panelClassName: 'smart-wardrobe-datepicker action-duration-end-picker',
                    appendTo: 'self',
                }}
                value={form.endDate}
                mandatory={true}
                onChangeCallback={onEndChangeCallback}
                minDate={form.startDate}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.task.duration.end.placeholder',
                    defaultMessage: 'Select end date',
                })}
                visible={isPickerEndVisible}
                onFocus={onFocusEnd}
                onVisibleChange={onVisibleChange}
                showCustom
                style={{ backgroundColor: Color.WHITE }}
                disabled={disabled}
                dateFormat={props.language?.split('-')[0] === 'tr' ? "dd/mm/yy" : undefined}
            />
            <LuxSelect
                value={form.recipient}
                disabled={disabled}
                mandatory={true}
                onChangeCallback={(value) => onSave({ recipient: value })}
                options={recipientList.map((recipient) => ({
                    ...recipient,
                    label: intl.formatMessage({
                        id: recipient.label,
                        defaultMessage: recipient.label.split('.').pop(),
                    }),
                }))}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.task.duration.recipient',
                    defaultMessage: 'Select recipient',
                })}
                additionalProps={{
                    appendTo: 'self',
                }}
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    recipientList: state[FILTERS_REDUCER_NAMESPACE].recipientList,
    language: state.userReducer.user.language,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Duration)
